export let storeColumns = [
	{
		attr: "guid",
		label: "Наименование",
		type: 1,
		hidden: true
	}, {
		attr: "codeid",
		label: "ID",
		type: 1,
		editor: false
	}, {
		attr: "name",
		label: "Название",
		type: 1,
		editor: true
	}, {
		attr: "min_cost",
		label: "min_cost",
		type: 2,
		editor: true,
		hidden: false
	}, {
		attr: "link",
		label: "Ссылка",
		type: 1,
		editor: true,
		hidden: false
	}, {
		attr: "max_cost",
		label: "max_cost",
		type: 2,
		editor: true,
		hidden: false
	}, {
		attr: "category_guid",
		label: "category_guid",
		type: 3,
		editor: true,
		hidden: true,
		opt: 1,

	}, {
		attr: "country_guid",
		label: "Страна",
		type: 3,
		editor: true,
		hidden: true,
		opt: 5,
		optionLabel: "country"
	}, {
		attr: "logo",
		label: "Logo",
		type: 1,
		editor: true,
		type: 5,
		accept: "image/*"
	}
]